export const VIRTUAL_APPOINTMENT_STATUSES = [
    'planned',
    'open',
    'waiting_patient',
    'waiting_doctor',
    'done',
    'canceled'
] as const;
export type VirtualAppointmentStatus = (typeof VIRTUAL_APPOINTMENT_STATUSES)[number];

export const VIRTUAL_APPOINTMENT_TEAMS = ['DM', 'Clinical'] as const;
export type VirtualAppointmentTeam = (typeof VIRTUAL_APPOINTMENT_TEAMS)[number];

// Every stored kind; 'now' is written only by "open VAs now", so no picker offers it.
export const VIRTUAL_APPOINTMENT_TRIGGER_KINDS = ['aligner', 'weeks', 'nogos', 'now'] as const;
export type VirtualAppointmentTriggerKind = (typeof VIRTUAL_APPOINTMENT_TRIGGER_KINDS)[number];

// Shared by every surface that loads VAs: the wizard planner, recaps and the work-queue task.
export type VirtualAppointmentLoadStatus = 'loading' | 'error' | 'ready';
